import React from 'react'
import ClusterManager from '../oam/components/cluster-manager/ClusterManager'

const  CollegeClusterManager = () => {
  return (
    <div>
        <ClusterManager mode="college-oam"/>
    </div>
  )
}

export default CollegeClusterManager